if (!customElements.get('ssw-gift-hint')) {
  customElements.define(
    'ssw-gift-hint',
    class SswGiftHint extends HTMLElement {
      constructor() {
        super();
        this.urlToShare = window.location.href;
      }

      connectedCallback() {
        if (this.dataset.sswGiftHintInit === 'true') return;
        this.dataset.sswGiftHintInit = 'true';

        this.trigger = this.querySelector('.ssw-gift-hint__trigger');
        const modalId = this.trigger?.getAttribute('aria-controls');
        this.modal = modalId ? document.getElementById(modalId) : null;

        if (!this.trigger || !this.modal) return;

        this.noteField = this.modal.querySelector('[data-gift-hint-note]');
        this.statusEl = this.modal.querySelector('[data-gift-hint-status]');
        this.urlInput = this.modal.querySelector('[data-gift-hint-url]');

        if (this.urlInput) this.urlToShare = this.urlInput.value;

        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.openModal();
        });

        this.modal.querySelectorAll('[data-share-type]').forEach((button) => {
          button.addEventListener('click', () => this.handleShare(button.dataset.shareType));
        });
      }

      openModal() {
        if (!this.modal?.show) return;

        this.clearStatus();
        this.modal.show(this.trigger);
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.urlInput) this.urlInput.value = url;
      }

      buildMessage() {
        const title = this.dataset.productTitle || document.title;
        const note = this.noteField?.value.trim();
        let message = `I'd love this: ${title}`;
        if (note) message += ` — ${note}`;
        message += ` ${this.urlToShare}`;
        return message;
      }

      handleShare(type) {
        const message = this.buildMessage();
        const url = this.urlToShare;
        const subject = this.dataset.emailSubject || `Gift hint: ${this.dataset.productTitle || 'Smart Swimwear'}`;

        switch (type) {
          case 'email':
            window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
            this.showStatus(this.dataset.openingEmail || 'Opening email…');
            break;
          case 'whatsapp':
            window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
            break;
          case 'telegram':
            window.open(
              `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(message)}`,
              '_blank',
              'noopener,noreferrer'
            );
            break;
          case 'copy':
            this.copyLink(message);
            break;
          default:
            break;
        }
      }

      copyLink(message) {
        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(message).then(() => {
            this.showStatus(this.dataset.copySuccess || 'Link copied');
          });
          return;
        }

        const textarea = document.createElement('textarea');
        textarea.value = message;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.showStatus(this.dataset.copySuccess || 'Link copied');
      }

      showStatus(message) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message;
        this.statusEl.classList.remove('hidden');
      }

      clearStatus() {
        if (!this.statusEl) return;
        this.statusEl.textContent = '';
        this.statusEl.classList.add('hidden');
      }
    }
  );
}
